import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 25000,
});

// Small helper: retry a request on transient network errors (connection lost,
// timeout, 502/503/504). Never retries on 4xx client errors.
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
export async function postWithRetry(url, body, { attempts = 3, delayMs = 1500 } = {}) {
  let lastErr;
  for (let i = 0; i < attempts; i++) {
    try {
      return await api.post(url, body);
    } catch (e) {
      lastErr = e;
      const status = e?.response?.status;
      const isNetwork = !e?.response || e?.code === "ECONNABORTED" || e?.code === "ERR_NETWORK";
      const isTransient = isNetwork || status === 502 || status === 503 || status === 504;
      if (!isTransient || i === attempts - 1) throw e;
      await sleep(delayMs * (i + 1));
    }
  }
  throw lastErr;
}
